import TextField from "@/includes/fields/TextField";
import Field from "@/includes/fields/Field";

export default class MaskedTextField extends TextField {

    mask: Array<string>

    constructor(label: string, value: string, placeholder: string, mask: Array<string>) {
        super(label, value, placeholder);
        this.mask = mask
    }

    isEmpty(): boolean {
        return super.isEmpty();
    }

    clear = (): Field => {
        this.setValue('')
        return this;
    };

    getType = (): string => 'masked'
}